module.exports = __webpack_public_path__ + "static/pw-exp-6505878ea231210ba6b8ba4a05ec59d0.svg";